// cart-checker.js
document.addEventListener('DOMContentLoaded', function() {
  class CartChecker {
    constructor() {
      this.cartItemCount = 0;
      this.init();
    }

    init() {
      this.checkCartStatus();
      this.bindEvents();
      this.startCartMonitoring();
    }

    async checkCartStatus() {
      try {
        const response = await fetch('/cart.json');
        const cart = await response.json();
        this.cartItemCount = cart.item_count;
        this.updateButtonStates(cart);
      } catch (error) {
        console.error('Error fetching cart:', error);
      }
    }

    updateButtonStates(cart) {
      const productForms = document.querySelectorAll('product-form');
      
      productForms.forEach(form => {
        const variantId = form.dataset.variantId;
        if (!variantId) return;

        const isInCart = cart.items.some(item => item.variant_id == variantId);
        const submitButton = form.querySelector('.product-form__submit, .quick-add__submit');
        const buttonText = submitButton.querySelector('.button-text');
        const dynamicCheckout = form.querySelector('.dynamic-checkout-wrapper');

        // Überprüfung ob Button bereits korrekt gesetzt ist
        const currentlyInCart = submitButton.classList.contains('in-cart');
        
        if (isInCart && !currentlyInCart) {
          submitButton.disabled = true;
          submitButton.classList.add('in-cart');
          if (buttonText) {
            buttonText.textContent = submitButton.dataset.inCartText || 'Bereits in deiner Auswahl';
          }
          
          // Dynamic Checkout Button verstecken
          if (dynamicCheckout) {
            dynamicCheckout.style.display = 'none';
          }
        } else if (!isInCart && currentlyInCart) {
          // Ursprünglichen Zustand wiederherstellen
          const originalDisabled = submitButton.hasAttribute('data-originally-disabled');
          submitButton.disabled = originalDisabled;
          submitButton.classList.remove('in-cart');
          
          if (buttonText) {
            buttonText.textContent = submitButton.dataset.originalText || 'In den Warenkorb';
          }
          
          // Dynamic Checkout Button wieder anzeigen
          if (dynamicCheckout) {
            dynamicCheckout.style.display = 'block';
          }
        }
      });
    }

    startCartMonitoring() {
      // Überwachung des Warenkorb-Counts alle 2 Sekunden
      setInterval(async () => {
        try {
          const response = await fetch('/cart.json');
          const cart = await response.json();
          
          // Nur aktualisieren wenn sich die Anzahl geändert hat
          if (cart.item_count !== this.cartItemCount) {
            this.cartItemCount = cart.item_count;
            this.updateButtonStates(cart);
          }
        } catch (error) {
          console.error('Error monitoring cart:', error);
        }
      }, 2000);
    }

    bindEvents() {
      // Bei Varianten-Änderung neu prüfen
      document.addEventListener('variant:change', () => {
        setTimeout(() => this.checkCartStatus(), 100);
      });

      // Alle möglichen Cart-Events abfangen
      const cartEvents = [
        'cart:build', 'cart:refresh', 'cart:update', 'cart:change', 
        'cart:updated', 'cart:items-changed', 'shopify:section:load'
      ];
      
      cartEvents.forEach(eventName => {
        document.addEventListener(eventName, () => {
          setTimeout(() => this.checkCartStatus(), 500);
        });
      });

      // MutationObserver für DOM-Änderungen (z.B. wenn Cart-Drawer aktualisiert wird)
      const observer = new MutationObserver((mutations) => {
        let cartChanged = false;
        mutations.forEach((mutation) => {
          if (mutation.target.classList && 
              (mutation.target.classList.contains('cart') || 
               mutation.target.classList.contains('cart-drawer') ||
               mutation.target.id === 'cart-drawer' ||
               mutation.target.closest('.cart') ||
               mutation.target.closest('[id*="cart"]'))) {
            cartChanged = true;
          }
        });
        
        if (cartChanged) {
          setTimeout(() => this.checkCartStatus(), 500);
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });

      // Form Submit Event abfangen
      document.addEventListener('submit', (e) => {
        if (e.target.dataset.type === 'add-to-cart-form') {
          const form = e.target.closest('product-form');
          const submitButton = form.querySelector('.product-form__submit, .quick-add__submit');
          
          if (submitButton.classList.contains('in-cart')) {
            e.preventDefault();
            return false;
          }

          // Nach erfolgreichem Submit den Status aktualisieren
          setTimeout(() => this.checkCartStatus(), 1000);
        }
      });

      // Click-Events auf Cart-Remove Buttons abfangen
      document.addEventListener('click', (e) => {
        if (e.target.matches('[name="updates[]"]') || 
            e.target.closest('.cart-remove') ||
            e.target.closest('[href*="change"]') ||
            e.target.matches('.quantity__button') ||
            e.target.closest('.quantity__button')) {
          setTimeout(() => this.checkCartStatus(), 1000);
        }
      });

      // Storage Events (falls andere Tabs den Warenkorb ändern)
      window.addEventListener('storage', (e) => {
        if (e.key && e.key.includes('cart')) {
          setTimeout(() => this.checkCartStatus(), 500);
        }
      });
    }
  }

  // CartChecker initialisieren
  new CartChecker();
});